export default "__VITE_ASSET__DeMdzO$3__"